import { ErrorMessage } from "formik";
import React from "react";

const CustomInput = React.memo(
  ({
    field,
    form: { touched, errors },
    label,
    placeholder,
    required,
    icon,
    iconClass,
    noMarginBottom,
    numberTypeWithoutDot = false,
    ...props
  }) => {
    const numberInputOnWheelPreventChange = (e) => {
      let isFocused = false;
      if (document.activeElement == e.target) {
        isFocused = true;
      }

      // Prevent the input value change
      e.target.blur();

      // Prevent the page/container scrolling
      e.stopPropagation();

      if (isFocused) {
        // Refocus immediately, on the next tick (after the current function is done)
        setTimeout(() => {
          e.target.focus();
        }, 0);
      }
    };

    const numberInputKeyDownPreventChange = (e) => {
      const { key } = e;
      const keyCode = e.charCode || e.keyCode;

      // Disable Up and Down Arrows on Keyboard
      // Also prevent e(69) when type is number
      if (
        keyCode === 38 ||
        keyCode === 40 ||
        (props?.type === "number" &&
          (key === "e" || key === "+" || key == "-")) ||
        (props?.type === "number" &&
          numberTypeWithoutDot === true &&
          key === ".")
      ) {
        e.preventDefault();
      } else {
        return;
      }
    };

    return (
      <div className={`${noMarginBottom == true ? "" : "mb-2"}`}>
        {label && (
          <label className="mb-1">
            {label} {required && <span className="text-danger">*</span>}
          </label>
        )}

        {icon || props.passwordEye ? (
          <div className="input-group">
            {icon ? (
              <span className="input-group-text">
                <i className={iconClass}></i>
              </span>
            ) : (
              ""
            )}
            <input
              {...field}
              {...props}
              placeholder={placeholder}
              // invalid={touched[field.name] && !!errors[field.name]}
              // valid={touched[field.name] && !errors[field.name]}
              autoComplete={"off"}
              className={`form-control form-control-sm ${
                props.passwordEye ? "passwordInput" : ""
              }`}
              onWheel={numberInputOnWheelPreventChange} // to Prevent the input value change on mouse scroll
              onKeyDown={numberInputKeyDownPreventChange} // to Disable Up and Down Arrows on Keyboard
            />
            {props.passwordEye ? (
              <div
                className="input-group-text "
                onClick={(e) =>
                  props.setIsPassword(props.type === "password" ? false : true)
                }
                title={`${props.type === "password" ? "show" : "hide"}`}
              >
                {" "}
                {props.type === "password" ? (
                  <i className="fa fa-eye-slash" />
                ) : (
                  <i className="fa fa-eye" />
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <input
            {...field}
            {...props}
            placeholder={placeholder}
            // invalid={touched[field.name] && !!errors[field.name]}
            // valid={touched[field.name] && !errors[field.name]}
            autoComplete={"off"}
            className="form-control form-control-sm mt-0"
            onWheel={numberInputOnWheelPreventChange} // to Prevent the input value change on mouse scroll
            onKeyDown={numberInputKeyDownPreventChange} // to Disable Up and Down Arrows on Keyboard
          />
        )}
        <ErrorMessage
          name={field.name}
          component="div"
          className="invalid-feedback animated fadeInUp"
          style={{ display: "block" }}
        />
      </div>
    );
  }
);

export default CustomInput;
